// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"28":"c84b5bea","110":"8b2e1964","239":"4313354b","556":"77329c1e","758":"83f0b21f","854":"37540bce"}[chunkId] + ".chunk.js";
};